export const SERVER_URL = 'https://apicron.redpergamino.net/'
